export enum WebsocketEnums {
  notificationsChannelName = 'App.Models.User.',
  supportNotificationsChannelEvent = '.change-request.created'
}
